import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export interface TravelcheckContext {
    shopId: string;
    uuid: string;
    productCode: string;
}

@Injectable({ providedIn: 'root' })
export class TravelcheckContextService {
    private readonly storageKey = 'ito.travelcheck.context';
    private readonly browser: boolean;
    private readonly initialQuery: string;
    private initialCaptured = false;

    constructor(@Inject(PLATFORM_ID) platformId: object) {
        this.browser = isPlatformBrowser(platformId);
        this.initialQuery = this.browser ? window.location.search : '';
    }

    captureInitial(partnerId: string): void {
        if (this.initialCaptured || partnerId?.toLowerCase() !== 'ito') return;
        this.initialCaptured = true;
        this.capture(partnerId, this.initialQuery);
    }

    capture(partnerId: string, query: string): void {
        if (!this.browser || partnerId?.toLowerCase() !== 'ito') return;
        const params = new URLSearchParams(query);
        if (!params.has('shopId') && !params.has('uuid') && !params.has('productCode')) return;
        const shopId = (params.get('shopId') || '').trim();
        const uuid = (params.get('uuid') || '').trim();
        const productCode = (params.get('productCode') || '').trim();
        try {
            if (!/^\d{1,20}$/.test(shopId) || uuid !== shopId || productCode !== 'R00') {
                window.sessionStorage.removeItem(this.storageKey);
                return;
            }
            window.sessionStorage.setItem(this.storageKey, JSON.stringify({ shopId, uuid, productCode }));
        } catch (_) {
            // Storage can be disabled by the browser; the backend will record a missing ShopID.
        }
    }

    get(partnerId: string): TravelcheckContext | null {
        if (!this.browser || partnerId?.toLowerCase() !== 'ito') return null;
        try {
            return JSON.parse(window.sessionStorage.getItem(this.storageKey) || 'null');
        } catch (_) {
            return null;
        }
    }
}
